// extracted by mini-css-extract-plugin
module.exports = {"content":"lORL3oB","suburbs":"JoyrOJO","heading":"_2RqXBNC","suburb":"_1R1C1Zy","link":"LMEn5sz","toggleLabel":"QxFiVbf","toggle":"_18RJUot","chevron":"_1EBo7GJ","chevronSvg":"_16n0k-R","toggleContent":"_2rP4aTl","more":"_37GPAWP","less":"pgl807r"};
    if(module.hot) {
      // 1545369437250
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  